import React from 'react';

import type { IntlShape } from 'react-intl';

import type { ADFEntity } from '@atlaskit/adf-utils/types';
import Image from '@atlaskit/image';
import type { HubElement } from '@atlassian/company-hub-common/types';

import { carouselExtensionKey, carouselExtensionType } from '../../constants';
import { carouselHubElementThumbnail, carouselHubElementThumbnailDark } from '../assets';
import { carouselParameters } from '../carousel-manifest';
import { messages } from './messages';

const getDefaultCarouselNodeAdf = (intl: IntlShape): ADFEntity => {
	const { formatMessage } = intl;

	return {
		type: 'extension',
		attrs: {
			extensionKey: carouselExtensionKey,
			extensionType: carouselExtensionType,
			parameters: carouselParameters({
				intl,
				extensionTitle: formatMessage(messages.carouselTitle),
			}),
		},
	};
};
const thumbnailImage: React.ReactNode = (
	<Image src={carouselHubElementThumbnail} srcDark={carouselHubElementThumbnailDark} alt="" />
);

export const carouselHubElement: HubElement = {
	extensionKey: carouselExtensionKey,
	title: messages.carouselTitle,
	description: messages.carouselDescription,
	Image: thumbnailImage,
	getNodeAdf: getDefaultCarouselNodeAdf,
};
